import { TariffAPI } from "@/api/TariffAPI";

export const tariffModule = {
    state: () => ({
      internetSpeedList: [10, 20, 50, 100],
      tvChanelList: [50, 70, 80, 100],
      tariffList: []
    }),
    getters: {
      internetSpeedList: state => state.internetSpeedList,
      tvChanelList: state => state.tvChanelList,
      tariffs: state => state.tariffList
    },
    mutations: {
      setTariffs(state, tariffs) {
          state.tariffList = tariffs
      },
    },
    actions: {
      async getAllTariffs({ commit }){
        return await TariffAPI.getTariffList('home-all')
          .then(res => {
            commit("setTariffs", res.data)
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async selectTariff({ commit, rootState }, tariff){
        return await TariffAPI.setTariff(rootState.authorization.userId, tariff)
          .then((response) => {
            return response.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
    },
    namespaced: true
}